<template>
  <div>
    <div>
      <p class="mb-4 mt-4 text-left text-dark-gray sm:mt-2">
        By clicking <strong>Sign & Continue</strong> you certify that you are
        authorized to sign the contract{{
          contracts?.length > 1 ? 's' : ''
        }}
        set forth below on behalf of {{ carrierLegalName }}, you have reviewed
        and accept the terms of each contract, and you intend to electronically
        sign each contract listed below. If you have any questions, please
        contact
        <a
          :href="'mailto:' + supportEmail"
          class="bold"
          >{{ `${supportEmail}.` }}</a
        >
      </p>
      <div class="flex flex-col gap-4">
        <div
          v-for="c in contracts"
          :key="c?.id"
          class="group w-full rounded-md border border-transparent hover:border-yellow-500"
        >
          <a
            :href="c?.contract?.url"
            target="_blank"
            class="flex items-center justify-between gap-2 rounded-md border border-light-gray px-6 py-4 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
          >
            <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg> -->
            <div class="flex gap-2 text-dark-gray">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-8 w-8"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                />
              </svg>
              <div class="flex flex-col items-start justify-center gap-0">
                <span class="leading-tight text-dark-gray">{{ c?.name }}</span>
                <span
                  class="hidden text-left text-xxs text-gray-over-dark sm:inline"
                  >{{ c?.contract?.filename }}</span
                >
              </div>
            </div>
            <div
              class="flex items-center gap-2 text-gray-over-dark group-hover:text-yellow-500"
            >
              <p class="m-0">View</p>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 5L0.749999 0.669874L0.749999 9.33013L6 5Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </a>
        </div>
        <div
          v-if="tax_form_contract_preview && !is_bypassing_tax_form"
          class="group w-full rounded-md border border-transparent hover:border-yellow-500"
        >
          <a
            :href="tax_form_contract_preview?.url"
            target="_blank"
            class="flex items-center justify-between gap-2 rounded-md border border-light-gray px-6 py-4 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
          >
            <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg> -->
            <div class="flex gap-2 text-dark-gray">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-8 w-8"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                />
              </svg>
              <div class="flex flex-col items-start justify-center gap-0">
                <span class="leading-tight text-dark-gray">{{
                  tax_form?.name
                }}</span>
                <span
                  class="hidden text-left text-xxs text-gray-over-dark sm:inline"
                  >{{ tax_form_contract_preview?.filename }}</span
                >
              </div>
            </div>
            <div
              class="flex items-center gap-2 text-gray-over-dark group-hover:text-yellow-500"
            >
              <p class="m-0">View</p>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 5L0.749999 0.669874L0.749999 9.33013L6 5Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      :final-button-loading="isButtonLoading"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore, mapState } from 'vuex';
import { computed, ref } from 'vue';

export default {
  name: 'ContractStepTwo',
  components: {
    FormNavigationButtons,
  },
  props: {
    data: Object,
    formPosition: Number,
    title: String,
    updateField: Function,
    nextStep: Function,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  data() {
    return {
      taxFormLoaded: false,
    };
  },
  computed: {
    ...mapState({
      carrierLegalName: (state) =>
        state.carriers?.carrierDetails?.legal_name || '',
      brokerLegalName: (state) => state.brokers?.logo?.legal_name || '',
      contracts: (state) => state.carriers?.contracts || [],
      onboarding_packet_id: (state) => state.onboardingPacket?.id || null,
      supportEmail: (state) =>
        state.carriers?.carrierData?.connection?.issuer?.support_email,
      legalName: (state) =>
        state.carriers?.carrierData?.connection?.issuer?.legal_name,
    }),
    latest_tax_form_submission() {
      if (this.$store.state.taxQuestions?.latest_tax_form_submission) {
        return this.$store.state.taxQuestions?.latest_tax_form_submission;
        // } else if (this.$store.state.carriers?.carrierData?.latest_tax_form_submission) {
        //   return this.$store.state.carriers?.carrierData?.latest_tax_form_submission;
      } else {
        return {};
      }
    },
    tax_form_contract_preview() {
      return this.latest_tax_form_submission?.tax_form_contract_preview || {};
    },
    is_bypassing_tax_form() {
      if (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.is_w9_optional == true &&
        this.$store.state.taxQuestions?.has_submitted_bypass_w9 == true
      ) {
        return true;
      } else if (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.is_w8_optional == true &&
        this.$store.state.taxQuestions?.has_submitted_bypass_w8 == true
      ) {
        return true;
      } else {
        return false;
      }
    },
    tax_form() {
      return this.latest_tax_form_submission?.tax_form || {};
    },
  },
  // async mounted() {
  //   if (!this.$store.state.carriers?.carrierData?.latest_tax_form_submission?.tax_form_contract_preview) {
  //     await this.$store.dispatch('taxQuestions/getLatestTaxFormSubmission', this.onboarding_packet_id);
  //   }
  // },
  watch: {
    stepName: async function (val) {
      if (val === 'Contract-2') {
        await this.$store.dispatch(
          'carriers/setContractInformation',
          this.$store.state.onboardingPacket?.id
        );
        // Enable Agree & Continue button if stepName is Contract-2
        this.$store.commit('toggleDisabledButton', {
          bool: false,
          source: 'ContractStepTwo #1',
        });
      }
    },
    // tax_form_contract_preview: function (val) {
    //   if (!(val && val !== {})) {
    //     this.$store.dispatch('taxQuestions/getLatestTaxFormSubmission', this.onboarding_packet_id);
    //   }
    // },
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Contract-2';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = 'finish-sign';
    const isButtonDisabled = false;
    const isButtonLoading = ref(false);

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      isButtonLoading.value = true;
      formRouter.moveToStepByIdentifier('AttemptToComplete');
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ': Manually redirecting to Contract-1'
      );
      formRouter.moveToStepByIdentifier('Contract-1');
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      isButtonLoading,
      emitExitModal,
    };
  },
};
</script>

<style scoped>
p {
  @apply text-left;
}
</style>
